import ChangeModal from '../ChangeModal/change-modal';

export default ChangeModal;